/**
 * HTML 消毒工具
 * 封装 DOMPurify，统一配置，防止 XSS
 */
import DOMPurify from 'dompurify'

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'b', 'em', 'i',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li', 'code', 'span', 'img', 'div'
]

const ALLOWED_ATTR = [
  'class', 'src', 'alt', 'referrerpolicy', 'title'
]

/**
 * 对 HTML 字符串进行消毒
 * @param {string} html - 原始 HTML 字符串
 * @returns {string} 消毒后的 HTML 字符串
 */
export function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') return ''
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    SANITIZE_DOM: true,
    KEEP_CONTENT: true
  })
}

export default sanitizeHtml
